import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./detailpage.css";

import generalOtBanner from "../../images/general-ot-drape-banner.jpg";
import generalOtone from "../../images/pdpimage/generalotone.jpg";
import generalOttwo from "../../images/pdpimage/generalottwo.jpg";
import generalOtthree from "../../images/pdpimage/generalotone.jpg";
import generalOtfour from "../../images/pdpimage/generalottwo.jpg";

const whatsappNumber = "+919619065205";

const PRODUCT_IMAGES = [
  { id: "img1", src: generalOtone, alt: "General OT Drape - Full View" },
  { id: "img2", src: generalOttwo, alt: "General OT Drape - Folded Pack" },
  { id: "img3", src: generalOtthree, alt: "General OT Drape - Fenestration Close-Up" },
  { id: "img4", src: generalOtfour, alt: "General OT Drape - Adhesive Zone" },
];

const ContactBanner = () => (
  <div className="contact-banner">
    <h3>Need guidance choosing the right drape?</h3>
    <p>Our clinical support team is here to assist you.</p>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of General OT Drapes. Please share more details.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Bulk Quote
    </a>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your General OT Drapes.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Brochure
    </a>
  </div>
);

const GeneralOTDrape = () => {
  useEffect(() => {
    document.title = "General OT Drape - Versatile Sterile Draping Solution";
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  const mainImage = PRODUCT_IMAGES[activeIndex];

  return (
    <>
      {/* Hero Section */}
      <section
        className="homepage-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${generalOtBanner})`,
        }}
      >
        <h1 className="homepage-hero-title">General OT Drape</h1>
        <p className="homepage-hero-subtext">
          Versatile, Sterile Draping Solution for Multi-Specialty Surgical Setups
        </p>
        <div className="homepage-hero-buttons">
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of General OT Drapes. Please share more details.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Bulk Quote
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your General OT Drapes.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Brochure
          </a>
        </div>
      </section>

      {/* Product Overview */}
      <section className="mw-product-details mw-container">
        <div className="mw-gallery">
          {/* Main Image Viewer */}
          <div className="mw-gallery-main">
            <img
              src={mainImage.src}
              alt={mainImage.alt}
              className="main-gallery-image"
            />
          </div>

          {/* Thumbnail Gallery */}
          <div className="mw-gallery-thumbs">
            {PRODUCT_IMAGES.map((img, index) => (
              <div
                key={img.id}
                className={`gallery-thumb-img-box ${index === activeIndex ? "active-thumb" : ""}`}
                onClick={() => setActiveIndex(index)}
              >
                <img src={img.src} alt={img.alt} loading="lazy" />
              </div>
            ))}
          </div>
        </div>

        {/* Product Info */}
        <div className="mw-product-info" id="contact">
          <h2 className="homepage-section-title">Product Overview</h2>
          <p>
            Our General OT Drapes are designed to accommodate a wide range of
            surgical procedures, offering flexibility, full coverage, and
            infection control. These universal drapes are ideal for general
            surgeries, outpatient procedures, and diagnostic interventions.
          </p>
          <ul className="mw-list">
            <li>Universal fenestration or plain sheet options</li>
            <li>Available with or without fluid collection pouches</li>
            <li>Impermeable material with reinforced zones</li>
            <li>Secure adhesive zones for reliable placement</li>
            <li>Sterile and non-sterile variants available</li>
          </ul>

          <h2 className="homepage-section-title">Technical Specifications</h2>
          <table className="mw-specs-table">
            <thead>
              <tr>
                <th>Parameter</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Material</td>
                <td>SMS/SMMS with PE coating (optional)</td>
              </tr>
              <tr>
                <td>Size</td>
                <td>180 x 200 cm / 200 x 220 cm (customizable)</td>
              </tr>
              <tr>
                <td>Fenestration</td>
                <td>Plain, circular, or slit fenestration</td>
              </tr>
              <tr>
                <td>Sterility</td>
                <td>EO Sterilized or non-sterile option</td>
              </tr>
              <tr>
                <td>Packaging</td>
                <td>Individually packed; 25 pcs/carton</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Compliance */}
      <section className="mw-compliance">
        <h2 className="homepage-section-title">Certifications & Standards</h2>
        <ul className="mw-cert-list">
          <li>
            <span className="checkmark">✅</span>
            <span>ISO 13485:2016</span>
          </li>
          <li>
            <span className="checkmark">✅</span>
            <span>EN 13795 High Performance</span>
          </li>
          <li>
            <span className="checkmark">✅</span>
            <span>MDR Compliant</span>
          </li>
        </ul>
      </section>

      {/* Footer CTA */}
      <ContactBanner />
    </>
  );
};

export default GeneralOTDrape;
